import { createSelector } from 'reselect';

const selectSettlements = (state: any) => state.settlements;


export const selectSettlementCurrentItem = createSelector([selectSettlements], (settlements) => settlements.current);

export const selectSettlementsListItems = createSelector([selectSettlements], (settlements) => settlements.list);

export const selectSettlementItemById = (itemId: any) =>
    createSelector(selectSettlementsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectSettlementQueryItems = createSelector([selectSettlements], (settlements) => settlements.query);

export const selectSettlementCreatedItem = createSelector([selectSettlements], (settlements) => settlements.create);

export const selectSettlementUpdatedItem = createSelector([selectSettlements], (settlements) => settlements.update);

export const selectSettlementReadItem = createSelector([selectSettlements], (settlements) => settlements.read);

export const selectSettlementDeletedItem = createSelector([selectSettlements], (settlements) => settlements.delete);

export const selectSettlementSearchedItems = createSelector([selectSettlements], (settlements) => settlements.search);

export const selectSettlementItemsCount = createSelector([selectSettlements], (settlements) => settlements.count);

export const selectSettlementItemsFilter = createSelector([selectSettlements], (settlements) => settlements.filter);